import React, { useState, useEffect } from "react";
import "./Slideshow.css"; // or inline styling if you prefer

const paintingImages = [
  {
    url: "https://arely-media.s3.us-east-1.amazonaws.com/Painting+wall+residential.jpg",
    alt: "Painting wall residential"
  },
  {
    url: "https://arely-media.s3.us-east-1.amazonaws.com/Painting+Ceiling+residential.jpg",
    alt: "Painting Ceiling residential"
  },
  {
    url: "https://arely-media.s3.us-east-1.amazonaws.com/Painting+thumbnail+main.jpg",
    alt: "Painting thumbnail main"
  },
  {
    url: "https://arely-media.s3.us-east-1.amazonaws.com/Painting+before+and+after.jpg",
    alt: "Painting before and after"
  },
  {
    url: "https://arely-media.s3.us-east-1.amazonaws.com/Interior+of+a+beautifully+painted+home.jpg",
    alt: "Interior of a beautifully painted home"
  },
  {
    url: "https://arely-media.s3.us-east-1.amazonaws.com/image_for_the_slideshow.jpg",
    alt: "Exterior of a beautifully painted home"
  },
];

export default function Slideshow() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (!isPaused) {
      const timer = setTimeout(() => {
        nextSlide();
      }, 3000); // 3 seconds
      return () => clearTimeout(timer);
    }
  }, [currentIndex, isPaused]);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === paintingImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? paintingImages.length - 1 : prevIndex - 1
    );
  };

  const handleImageClick = () => {
    setIsPaused(true);
  };

  return (
    <div className="slideshow-container">
      <div className="slide" onClick={handleImageClick}>
        <img
          src={paintingImages[currentIndex].url}
          alt={paintingImages[currentIndex].alt}
          className="slideshow-image"
        />
      </div>
      <button className="prev-btn" onClick={prevSlide}>◀</button>
      <button className="next-btn" onClick={nextSlide}>▶</button>
    </div>
  );
}
